import React, { Fragment, useEffect } from 'react';

import { localeFormattedPrice } from 'common/utils';
import facility from 'app/facility';
import { colors } from 'app/variables';
import { SuccessIcon } from 'app/commonComponents/icons';
import form from 'modules/ticketPublicPage/stores/vouchers/form';
import {
  Container,
  IconContainer,
  PriceDisplay,
  PurchaseDetails,
  SuccessfulFormContainer,
} from './styles/_confirmation';
import { Divider } from './styles/_buyVoucher';

const Confirmation = () => {
  const { formValues } = form;
  const { settings, languageCode } = facility;
  const { logo, currency } = settings;
  useEffect(() => {
    document.body.scrollTop = 0;
  }, []);
  return (
    <Fragment>
      <Container>
        <IconContainer>
          <SuccessIcon
            style={{
              color: colors.pacificBlue,
              paddingBottom: '0.5rem',
              height: '3.25rem',
              width: '3.25rem',
            }}
          />
          <div>{i18n.gettext('Thank you!')}</div>
        </IconContainer>
        <SuccessfulFormContainer>
          {logo && (
            <img aria-hidden="true" src={logo} style={{ height: '5rem' }} />
          )}
          <PriceDisplay missingLogo={!logo}>
            <div>{i18n.gettext('Vouchers')}</div>
            <div>
              {localeFormattedPrice(formValues.get('price') || 10, {
                languageCode: languageCode,
                currencyCode: currency,
              })}
            </div>
          </PriceDisplay>
          <PurchaseDetails
            role="region"
            aria-label={i18n.gettext('Your purchase details:')}
          >
            <div>
              <span style={{ fontSize: '0.8rem' }}>
                {i18n.gettext('Your purchase:')}
              </span>
              <span>
                {i18n.gettext('voucher for ')}{' '}
                {formValues.get('recipient_name')}{' '}
                {formValues.get('recipient_surname')}
              </span>
            </div>
            <div>
              <span style={{ fontSize: '0.8rem' }}>
                {i18n.gettext('Voucher code ')}
              </span>
              <span>{formValues.get('ref_num')}</span>
            </div>
          </PurchaseDetails>
        </SuccessfulFormContainer>
      </Container>
      <Divider />
      <div
        style={{
          padding: '0 1rem 1rem 1rem',
          marginTop: '1rem',
          textAlign: 'center',
          color: colors.pacificBlue,
        }}
      >
        {i18n.gettext(
          'We have sent you a confirmation and the voucher via email'
        )}
      </div>
    </Fragment>
  );
};

export default Confirmation;
